class PurchasesPieChart {
	constructor(card) {
		this.card = card;
		this.segments = Array.from(card.querySelectorAll('.purchases-pie-card__segment'));
		this.legendItems = Array.from(card.querySelectorAll('[data-purchases-pie-legend-item]'));
		this.hasAnimated = false;
		this.animationDelay = 650;

		this.init();
	}

	init() {
		if (!this.segments.length) {
			return;
		}

		this.reset();

		this.observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting || this.hasAnimated) {
						return;
					}

					this.animate();
					this.hasAnimated = true;
					this.observer.unobserve(this.card);
				});
			},
			{
				threshold: 0.45,
			}
		);

		this.observer.observe(this.card);
	}

	reset() {
		this.segments.forEach((segment) => {
			segment.style.strokeDasharray = '0 100';
		});

		this.legendItems.forEach((item) => {
			item.classList.remove('is-visible');
		});
	}

	animate() {
		this.segments.forEach((segment, index) => {
			const percent = Number.parseFloat(segment.dataset.percent || '0');
			const legendItem = this.legendItems[index];

			if (!Number.isFinite(percent) || percent <= 0) {
				return;
			}

			window.setTimeout(() => {
				segment.style.strokeDasharray = `${percent} ${100 - percent}`;

				if (legendItem) {
					legendItem.classList.add('is-visible');
				}
			}, index * this.animationDelay);
		});
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const cards = document.querySelectorAll('[data-purchases-pie-card]');

	cards.forEach((card) => {
		new PurchasesPieChart(card);
	});
});